// Copyright 2024 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useEffect } from 'react';
import styles from './ConfirmationDialog.module.css';

export const ConfirmationDialog = ({ message, confirm, handleConfirm, cancel, handleCancel }) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        handleCancel();
      }
      if (e.key === 'Enter') {
        handleConfirm();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleConfirm, handleCancel]);

  return (
    <div className={styles.confirmationOverlay}>
      <div className={styles.confirmationBox}>
        <p>{message}</p>
        <div className={styles.confirmBoxButtonWrapper}>
          {confirm && (
            <button onClick={handleConfirm} className={styles.confirmButton}>
              {confirm}
            </button>
          )}
          <button onClick={handleCancel} className={styles.cancelButton}>
            {cancel}
          </button>
        </div>
      </div>
    </div>
  );
};
